<template>
  <Form ref="trimForm" :model="trim" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="trim.id" type="hidden"/>

    <FormItem  :label="this.$t('property.trim.areaId.label')" prop="areaId">
      <Select v-model="trim.areaId" filterable placeholder="请选择区域">
        <Option  v-for="item in model12" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('property.trim.trimTime.label')" prop="trimTime">
      <Date-picker :value="trim.trimTime" type="datetime"  @on-change="setTimeFormat"
                   :placeholder="this.$t('property.trim.trimTime.holder')"></Date-picker>
    </FormItem>

    <FormItem  :label="this.$t('property.trim.trimPeople.label')" prop="trimPeople">
      <Select v-model="trim.trimPeople" filterable placeholder="请选择负责人">
        <Option  v-for="item in model11" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
     <!-- <InputNumber v-model="trim.trimPeople" :placeholder="$t('property.trim.trimPeople.holder')"/>-->
    </FormItem>

    <FormItem  :label="this.$t('property.trim.remark.label')" prop="remark">
      <Input v-model="trim.remark" :placeholder="$t('property.trim.remark.holder')"/>
    </FormItem>
  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      model12: [],
      model11: [],
      trim: {
        id: null,
        areaId: [],
        trimTime: null,
        trimPeople: [],
        remark: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    setTimeFormat(str, date){
      console.log(str)
      var datetime =  new Date(str);
      this.trim.trimTime = str;
      console.log(this.trim);
      // console.log(datetime);
    },
    handleSubmit(then,error){
      this.$refs['trimForm'].validate(valid => {
        if (valid) {
          if (this.trim.id) {
            this.updateTrim(this.trim).then(then).error(error)
          } else {
            this.createTrim(this.trim).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleAreaList(){
      this.loading = true;
      api.property.GreenArea.listAreaInfo()
        .then(data=>{
          this.model12 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handlePeopleList(){
      this.loading = true;
      api.property.Employees.listEmployeesInfo()
        .then(data=>{
          this.model11 = data;
          //this.employees.jobId = data;
          this.loading=false;
        }).catch(error=> this.loading = false)
    },
    handleReset(){
      this.trim.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['trimForm'].resetFields());
      this.handleAreaList();
      this.handlePeopleList();
    },
    getTrim(id,type){
      this.loading = true;
      this.$refs['trimForm'].resetFields()
      api.property.Trim.detail(id).then(data => {
        this.trim.id = data.id;
        this.trim.areaId = data.areaId;
        this.trim.trimTime = data.trimTime;
        this.trim.trimPeople = data.trimPeople;
        this.trim.remark = data.remark;
        this.handleAreaList();
        this.handlePeopleList();
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createTrim(trim){
      this.loading = true;
      return api.property.Trim.add(trim)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateTrim(trim){
      this.loading = true;
      return api.property.Trim.update(trim)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      areaId: [{type: 'number', required: true, message: this.$t('property.trim.areaId.required'),trigger: 'blur'}],
      // trimTime: [{type: 'datetime', required: true, message: this.$t('property.trim.trimTime.required'),trigger: 'blur'}],
      trimPeople: [{type: 'number', required: true, message: this.$t('property.trim.trimPeople.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 255, message: this.$t('property.trim.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['trimForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
